'use client';

import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from '../../libs/utils';

export interface SwitchProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
}

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(({ checked, onCheckedChange, className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'relative peer inline-flex h-7.5 w-[3.125rem] p-tiny-small shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary-background-main data-[state=unchecked]:bg-neutral-background-high',
      className
    )}
    onCheckedChange={onCheckedChange}
    checked={checked}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'absolute transition-[left] duration-200 ease-in-out pointer-events-none block h-[1.625rem] w-[1.625rem] rounded-full bg-white elevation-small data-[state=checked]:left-[1.25rem] data-[state=unchecked]:left-0'
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
